var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"is-home-button has-text-weight-semibold",on:{"click":_vm.goHome}},[_vm._v(_vm._s(_vm.$t('rebook-home-button-label')))])}
var staticRenderFns = []

export { render, staticRenderFns }